module.exports = __webpack_public_path__ + "fonts/Lemon Tuesday.35147b2d.otf";